import React, { Component } from "react";

import classnames from "classnames";
import SBCLinkCell from "ComparePlans/Components/SBCLinkCell";
import AddToCartButton from "EmployerApplication/Components/shoppingCartSection/AddToCartButton";
import isIntuit from "Intuit/isIntuit";
import DentalMinimumWarning from "QuotePage/Components/DentalMinimumWarning";
import { connect } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { Collapse } from "Cobalt/Collapse";
import { PlanHeader, FeatureBox, MonthlyCost, CollapseToggle } from "Cobalt/Plan/Card";
import { Table, TR, TD } from "Cobalt/TableV2";
import { Card, CardSection } from "Common/Card/";
import { addPlanToCart } from "Common/CartService";
import { getCartMedicalPlanIds } from "Common/CartService/Selectors";
import { isSampleQuote } from "Common/EnterAges/Selectors";
import { Col, Row } from "Common/Grid";
import { Div } from "Common/HTML";

import type { DentalPlan } from "Utils/types";

import makeBem from "Utils/makeBem";

const ANALYTICS_LOCATION = "expanding_plan_card";
const bem = makeBem("DentalPlanCard");

type Props = {
  plan: DentalPlan;
  medicalPlanSelected: boolean;
  addPlanToCart: (arg0: string, arg1: DentalPlan) => unknown;
  isSampleQuote: boolean;
  role?: string | null | undefined;
  openModal: () => void;
};

type State = {
  isOpen: boolean;
};

class DentalCardDumb extends Component<Props, State> {
  state: State = {
    isOpen: false,
  };

  handleExpand = () => {
    AnalyticsTracking.trackEvent(this.state.isOpen ? "dental_plan_card_collapse" : "dental_plan_card_expand", {
      location: ANALYTICS_LOCATION,
    });

    this.setState({ isOpen: !this.state.isOpen });
  };

  renderPlanDetailsTable() {
    const { plan } = this.props;
    return (
      <Row>
        <Col sm={6}>
          <Table>
            <TR>
              <TD>Cleanings</TD>
              <TD>{plan.preventive_care}</TD>
            </TR>
            <TR>
              <TD>Root Canals</TD>
              <TD>{plan.fine_print.Endodontics["Root Canal (single)"]}</TD>
            </TR>
            <TR>
              <TD>Gum Cleaning</TD>
              <TD>{plan.fine_print.Periodontics["Deep Cleaning (Scaling & Planing, per quadrant)"]}</TD>
            </TR>
            <TR>
              <TD>Braces</TD>
              <TD>{plan.fine_print.Orthodontics.Adult}</TD>
            </TR>
          </Table>
        </Col>
        <Col sm={6}>
          <Table>
            <TR>
              <TD>Crowns</TD>
              <TD>{plan.fine_print.Crowns["Porcelain and Steel"]}</TD>
            </TR>
            <TR>
              <TD>Extractions</TD>
              <TD>{plan.fine_print["Tooth Extraction"].Normal}</TD>
            </TR>
            <TR>
              <TD>Cavities</TD>
              <TD>{plan.fine_print.Cavities["Filling (1 surface)"]}</TD>
            </TR>
            <TR>
              <TD>More Details</TD>
              <TD>
                <SBCLinkCell plan={plan} />
              </TD>
            </TR>
          </Table>
        </Col>
      </Row>
    );
  }

  renderStartApplicationButton() {
    const { plan, medicalPlanSelected, addPlanToCart, openModal } = this.props;
    return <AddToCartButton addPlanToCart={medicalPlanSelected ? addPlanToCart : openModal} planType="dental" plan={plan} />;
  }

  renderCurrentPlanButton() {}

  render() {
    const { plan, isSampleQuote } = this.props;
    const { average_monthly_premium: averageMonthlyPremium, prices_loading: isLoadingCosts } = plan;
    const { isOpen } = this.state;

    return (
      <Card mb={2} p={0} className={classnames(bem(), isIntuit() ? bem(null, "intuit") : null, this.state.isOpen ? bem(null, "open") : bem(null, "closed"))}>
        <CardSection p={4} className={bem("Summary")} onClick={this.handleExpand}>
          <PlanHeader plan={plan} />
          <FeatureBox plan={plan} title="Max Benefit" field="annual_maximum" format="currency" />
          <FeatureBox plan={plan} title="Deductible" field="deductible" format="currency" />
          <FeatureBox plan={plan} title="Preventative" field="preventive_care" format="capitalize" />
          <FeatureBox plan={plan} title="Network Type" field="plan_type" format="acronym" className="sm:max-md:hidden" />
          <DentalMinimumWarning plan={plan} />
          <Div className={bem("PlanHeaderActions")}>
            <MonthlyCost cost={averageMonthlyPremium} loading={Boolean(isLoadingCosts)} hasFootnote={isSampleQuote} />

            <CollapseToggle isExpanded={isOpen} toggle={this.handleExpand} />
          </Div>
        </CardSection>
        <Collapse in={this.state.isOpen} mountOnEnter>
          {/* This wrapping div is required for collapse to be smooth */}
          <div>
            <CardSection pt={0}>
              {this.renderPlanDetailsTable()}
              <Row pt={4}>
                <Col sm={4} smOffset={8}>
                  {this.props.role !== "enrolled" && this.renderStartApplicationButton()}
                  {this.props.role == "enrolled" && this.renderCurrentPlanButton()}
                </Col>
              </Row>
            </CardSection>
          </div>
        </Collapse>
      </Card>
    );
  }
}

const mapStateToProps = (state, _ownProps) => ({
  isSampleQuote: isSampleQuote(state),
  medicalPlanSelected: getCartMedicalPlanIds(state)?.length > 0,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  addPlanToCart: ({ planType, plan }) => {
    dispatch(
      addPlanToCart({
        planType,
        plan,
        tracking: {
          location: "dental_plan_card",
        },

        shouldClearDentalVision: false,
        continueToCart: true,
      }),
    );

    dispatch(
      addPlanToCart({
        planType: "life",
        plan: null,
        tracking: {
          location: "dental_plan_card",
        },

        shouldClearDentalVision: false,
        continueToCart: true,
      }),
    );
  },
});

const DentalCard = connect(mapStateToProps, mapDispatchToProps)(DentalCardDumb);

export default DentalCard;
